import {
  ArrowReloadHorizontalIcon,
  Cancel01Icon,
} from '@hugeicons/core-free-icons';
import type { Ticket } from '@sunrise-ui/api/events';
import { Colors, IconButton, Modal, PageHeader } from '@sunrise-ui/primitives';
import React, { useState } from 'react';
import { StyleSheet } from 'react-native';
import { TicketTransferForm } from './TicketTransferForm';

type Props = {
  ticket: Ticket;
  communityId: string;
};

export function TicketTransferButton({ ticket, communityId }: Props) {
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  return (
    <>
      <IconButton onPress={toggleModal} icon={ArrowReloadHorizontalIcon} />
      <Modal
        visible={showModal}
        hide={toggleModal}
        contentStyle={styles.modalContent}
      >
        <PageHeader header="Transfer Ticket" />
        <TicketTransferForm ticket={ticket} communityId={communityId} />
        <IconButton
          icon={Cancel01Icon}
          onPress={toggleModal}
          backgroundColor={Colors.purple0opacity50}
          style={styles.closeButton}
          size="medium"
        />
      </Modal>
    </>
  );
}

const styles = StyleSheet.create({
  modalContent: {
    gap: 32,
    justifyContent: 'space-between',
  },
  closeButton: {
    position: 'absolute',
    top: 16,
    right: 16,
  },
});
